export default "__VITE_ASSET__7tBdVWoO__"